module.exports = __webpack_public_path__ + "img/retrospect-52-mobile.f588b119.jpg";